import type { TOC } from '@ember/component/template-only';
import { or } from 'tio-ui/utilities';
import { PhWarning } from 'ember-phosphor-icons';
export interface DetailWithIconArgs {
  Args: {
    icon?: unknown;
    detail?: string;
    iconBgColor?: string;
  };
  Element: HTMLElement;
}

const DetailWithIcon: TOC<DetailWithIconArgs> = <template>
  <div class="flex items-center m-4">
    <div
      class="flex flex-grow-0 flex-shrink-0 justify-center items-center w-12 h-12 mr-[10px] rounded-full
        {{or @iconBgColor 'bg-gray-400'}}"
    >
      <div class="h-6 text-white">
        {{#if @icon}}
          <@icon @size="16" />
        {{else}}
          <PhWarning @size="16" />
        {{/if}}
      </div>
    </div>
    <div class="text-gray-400">
      {{@detail}}
    </div>
  </div>
</template>;

export default DetailWithIcon;
